import { BaseService } from './base-service';
export class ReportService {
    static exportPdfDailySlaughter(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        //let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        //let filename = "attività_" + dateString + ".xlsx";
        //BaseService.downloadFile(`reports/pdf/daily-slaughter?filter=${qs}`, filename, null);
        BaseService.downloadFile(`reports/pdf/daily-slaughter?filter=${qs}`, null, null);
    }
    static exportPdfTransportDocument(oid) {
        BaseService.downloadFile(`reports/pdf/transport-document/${oid}`, null, null);
    }
    static exportPdfDestinazioneCarcasse(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/pdf/destinazione-carcasse?filter=${qs}`, null, null);
    }
    static exportPdfDichiarazioneUsoDomestico(slaughterId) {
        BaseService.downloadFile(`reports/pdf/dich-uso-domestico/${slaughterId}`, null, null);
    }
    static exportPdfTracciabilita(ddtId) {
        BaseService.downloadFile(`reports/pdf/tracciabilita/${ddtId}`, null, null);
    }
    static exportPdfQualityWaste(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/pdf/quality-waste?filter=${qs}`, null, null);
    }
    static exportPdfSlaughterMonthlyTotals(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/pdf/slaughter-monthly-totals?filter=${qs}`, null, null);
    }
    static exportPdfQualityIncident(incidentId) {
        BaseService.downloadFile(`reports/pdf/quality-incident/${incidentId}`, null, null);
    }
    static exportPdfProductInternalLabels(ddtItemId) {
        BaseService.downloadFile(`reports/pdf/product-internal-labels/${ddtItemId}`, null, null);
    }
    static exportPdfProductLabelsWithLogo(ddtItemId, logoId) {
        BaseService.downloadFile(`reports/pdf/product-labels-logo/${ddtItemId}/${logoId}`, null, null);
    }
    static exportPdfProductLabelsWithoutLogo(ddtItemId) {
        BaseService.downloadFile(`reports/pdf/product-labels-nologo/${ddtItemId}`, null, null);
    }
}
